export default function hideSidebar(pathname) {
    let elements = ['ConstructorLayout','SecuenceConfiguration','BookInformation', 'Examenes']
    let paths = pathname.split('/')
    paths.shift()
    return elements.some(element => paths.includes(element))
}